import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';
import { toast } from 'react-toastify';

const BulkDeleteDisplays = {
  name: 'BulkDeleteDisplays',
  state: {
    loading: false,
    error: '',
    success: false,
  },
  reducers: {
    deleteRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        success: false,
      };
    },
    deleteSucceeded(state) {
      return {
        ...state,
        loading: false,
        error: '',
        success: true,
      };
    },
    deleteFailed(state, payload) {
      return {
        ...state,
        loading: false,
        error: payload,
        success: false,
      };
    },
    resetState(state) {
      return {
        ...state,
        loading: false,
        error: '',
        success: false,
      };
    },
  },
  effects: (dispatch) => ({
    async bulkDeleteDisplays({ display_ids, select_all_matching = false, search = '', sorted_by = '', sort = '' }) {
      try {
        this.deleteRequested();
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const url = `savvy/displays/bulk-delete`;
        const payload = {
          display_ids,
          select_all_matching,
          search,
          sorted_by,
          sort,
          user_id: userInfo.id,
          org_id: userInfo.org_id,
        };

        const response = await http.post(url, payload);

        if (response && response.data) {
          this.deleteSucceeded();

          const summary = response.data?.data?.summary;
          if (summary) {
            if (summary.failed_count > 0 || summary.blocked_count > 0) {
              toast.error(
                `${summary.deleted_count || 0} deleted, ${summary.blocked_count || 0} blocked, ${summary.failed_count || 0} failed. See details for more information.`,
                { autoClose: 5000 }
              );
            } else {
              toast.success(
                `${summary.deleted_count || 0} display(s) deleted successfully!`,
                { autoClose: 3000 }
              );
            }
          } else {
            toast.success(response.data.message || 'Displays deleted successfully!', {
              autoClose: 3000,
            });
          }

          dispatch({
            type: 'helper/show',
            payload: {
              type: 'success',
              message: response.data.message || 'Displays deleted successfully!',
              show: true,
            },
          });

          return { success: true, data: response.data };
        }
      } catch (err) {
        this.deleteFailed(err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
        return { success: false, error: err.message };
      }
    },
  }),
};

export default BulkDeleteDisplays;

